import GrComponentFactory from "../../gr_component_factory";
import AskTheAuthorBannerActions from "../../../react_actions/ask_the_author_banner_actions";

export default GrComponentFactory.createClass({
  displayName: "StartAnsweringButton",

  propTypes: {
    authorID: React.PropTypes.number.isRequired,
  },

  render() {
    return (
      <button className="gr-button gr-button--dark gr-button--medium askTheAuthorBanner__startAnswering"
              onClick={() => {AskTheAuthorBannerActions.optAuthorIntoQA(this.props.authorID);}}>
          Start Answering Questions
      </button>
    );
  },
});
